const WhatsAppButton = () => {
  const phoneNumber = '34602365996';
  const message = encodeURIComponent('Hola, me gustaría solicitar información sobre vuestros servicios de vaciado.');

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 animate-bounce-soft cursor-pointer group"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-3xl"></i>
      <span className="absolute right-full mr-3 bg-dark text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        ¡Escríbenos!
      </span>
    </a>
  );
};

export default WhatsAppButton;
